export function formatShortcutKeys(keys: string, os: string): string | string[] {
  // Check if this is a sequential hotkey (contains ">")
  if (keys.includes(">")) {
    // Split by ">" for sequential keys
    const sequentialParts = keys.split(">").map((part) => {
      // Each part might still have modifiers with "+"
      const formatted = formatSingleKey(part.trim(), os)
      // For sequential keys, we want each part as a single string
      return Array.isArray(formatted) ? formatted.join("") : formatted
    })
    return sequentialParts
  }

  // Regular hotkey with modifiers
  return formatSingleKey(keys, os)
}

function formatSingleKey(key: string, os: string): string | string[] {
  const parts = key.split("+").map((keyPart) => {
    switch (keyPart.toLowerCase()) {
      case "mod":
        return os.includes("win") ? "⌃" : "⌘"
      case "meta":
      case "cmd":
        return "⌘"
      case "ctrl":
        return "⌃"
      case "alt":
      case "option":
        return "⌥"
      case "shift":
        return "⇧"
      case "enter":
      case "return":
        return "↵"
      case "escape":
      case "esc":
        return "Esc"
      case "backspace":
      case "delete":
        return "⌫"
      case "tab":
        return "⇥"
      case "space":
        return "Space"
      case "up":
        return "↑"
      case "down":
        return "↓"
      case "left":
        return "←"
      case "right":
        return "→"
      default:
        // Preserve the original case for single letters
        return keyPart.length === 1 ? keyPart : keyPart.toUpperCase()
    }
  })

  return parts.length > 1 ? parts : parts[0]
}
